<template>
    <div class="jd-page--order">
        <k-tabs v-model="active" class="" sticky v-if="getOrders">
            <k-tab title="待鉴定">
                <order-list :status="CONST.ORDER_STATUS_WAIT" place="user" />
            </k-tab>
            <k-tab title="资料修正">
                <order-list :status="CONST.ORDER_STATUS_PAUSE" place="user" />
            </k-tab>
            <k-tab title="待评价">
                <order-list :status="CONST.ORDER_STATUS_FINISHED" place="user" />
            </k-tab>
            <k-tab title="已完成">
                <order-list :status="CONST.ORDER_STATUS_EVALUATE" place="user" />
            </k-tab>
            <k-tab title="全部订单">
                <order-list :status="0" place="user" />
            </k-tab>
        </k-tabs>
        <k-hr />
        <div v-if="pageCount>0">
            <k-pagination
                v-model="page"
                :page-count="pageCount"
                mode="simple"
                @change="pageChange"
            />
        </div>

    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import OrderList from "../components/order-list"
    export default {
        name: "my-order",
        data() {
            return {
                currentPage     : 1,
                active          : +this.$route.query.tab || 0,
                page            : +this.$route.query.page || 1,
                pageNum         : 20,
                total           : 0,
                pageCount       : 0,
                statusList      : [3,6,4,7,0],
                loading         : true,
            }
        },
        computed :{
            ...mapGetters("jianding", ["getOrders","CONST"]),
            ...mapGetters("account", ["myUid"]),
            orderList(){
                return this.getOrders(this.status)
            }

        },
        components : {
            OrderList
        },
        methods : {
            ...mapActions("jianding", ["loadOrders"]),
            getList(status){
                return this.getOrders(status)
            },
            async init(page){
                let {active, statusList} = this;
                let status = statusList[active];
                let query = {
                    status  : status,
                    uid     : this.myUid,
                    page    : page,
                    pageNum : this.pageNum
                };
                if(status === this.CONST.ORDER_STATUS_EVALUATE){
                    query.status = '4,7'
                }
                this.$toast.loading("正在加载");
                await this.loadOrders(query).then( R => {
                    this.total = R.total || 0;
                    this.pageCount = Math.ceil(R.total/this.pageNum)
                    console.log(R)
                });
                this.$toast.clear();
            },
            pageChange(page) {
                //console.log(page)
                this.page = page;
                this.goPage();
                this.init(page);
            },
            goPage(){
                this.$router.replace({
                    path : `/my/order?tab=${this.active}&page=${this.page}`
                })
            }
        },
        mounted() {
            if(this.myUid){
                this.init(1);
            }
        },
        watch : {
            myUid(nv){
                if(nv){
                    this.init(1);
                }
            },
            active(nv){
                this.page = 1;
                this.init(1);
                this.goPage()
            },
            $route: {
                handler: function(val, oldVal){
                    //this.init(1);
                },
                // 深度观察监听
                deep: true
            }
        }
    }
</script>